(() => {
function init(root){
 if(root.dataset.layoutReady)return;root.dataset.layoutReady='true';
 const info=root.querySelector('[data-product-information]'),main=info.querySelector('[data-product-info-main]'),layout=info.querySelector('[data-product-info-layout]'),reviews=info.querySelector('[data-product-reviews]');
 const description=info.querySelector('[data-product-description]');
 // Move existing sections intact; never invent or discard product information.
 const headings=[...description.querySelectorAll(':scope > h2,:scope > h3,:scope > h4')];
 headings.forEach(heading=>{
  const title=heading.textContent.trim().toLowerCase().replace(/[’']/g,'');
  let name=/^(whats included|what is included|included|in the box|package contents)$/.test(title)?'included':/^(use & care|use and care|care instructions|directions|how to use)$/.test(title)?'care':null;
  if(!name)return;
  const target=info.querySelector('[data-product-'+name+']');
  let node=heading.nextSibling;const moved=[];
  while(node&&!/^H[1-6]$/.test(node.nodeName)){moved.push(node);node=node.nextSibling;}
  if(!moved.length)return;
  moved.forEach(el=>target.append(el));heading.remove();
  info.querySelector('[data-product-tab="'+name+'"]').hidden=false;
 });
 const buttons=[...info.querySelectorAll('[data-product-tab]')];
 if(!reviews.querySelector('.vital-own-reviews,.vital-product-reviews')){buttons.find(b=>b.dataset.productTab==='reviews').hidden=true;}
 function select(name){
  buttons.forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.productTab===name)));
  info.querySelectorAll('[data-product-panel]').forEach(panel=>panel.hidden=panel.dataset.productPanel!==name);
  if(name==='reviews')main.append(reviews);else layout.after(reviews);
 }
 buttons.forEach(button=>button.addEventListener('click',()=>select(button.dataset.productTab)));
 root.querySelectorAll('a[href="#VitalProductReviews"]').forEach(link=>link.addEventListener('click',()=>select('reviews')));
 document.querySelectorAll('.vital-sticky-buy a[href="#VitalProductReviews"]').forEach(link=>link.addEventListener('click',()=>select('reviews')));
 select(buttons.find(b=>b.dataset.productTab==='reviews').hidden?'details':'reviews');
}
function all(){document.querySelectorAll('[data-regular-product]').forEach(init);}
all();document.addEventListener('shopify:section:load',all);
})();